import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import { BASE_URL } from '../context/Api';
import { FaUserAlt } from 'react-icons/fa';

const Homepage = () => {
  const { employeeNumber } = useContext(AuthContext);
  const [teacherData, setTeacherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/teachers/${employeeNumber}`);
        setTeacherData(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching teacher data:', error);
        setLoading(false);
      }
    };

    if (employeeNumber) {
      fetchTeacherData();
    }
  }, [employeeNumber]);

  const handleClassClick = (classID, classType) => {
    if (classType === 'Subject Level') {
      navigate(`/subject-level/${classID}`);
    } else if (classType === 'Form Level') {
      navigate(`/form-level/${classID}`);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!teacherData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-gray-700 text-xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="p-4 sm:p-8 bg-white shadow-md flex flex-col sm:flex-row items-center sm:justify-between">
        <div className="mb-4 sm:mb-0 text-center sm:text-left">
          <h1 className="text-lg font-semibold text-gray-900 mb-2">
            Welcome, {teacherData.teacherName}!
          </h1>
          <p className="text-gray-700">
            Employee Number: <span className="font-medium">{teacherData.employeeNumber}</span>
          </p>
        </div>
        {/* Mini Profile Section */}
        <div className="flex items-center justify-center">
          <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
            <FaUserAlt className="text-gray-600 text-lg" />
          </div>
        </div>
      </div>

      {/* Classes Section */}
      <div className="p-4 sm:p-6">
        <div className="grid grid-cols-1 gap-8">
          {/* Form Level Classes */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4 sm:mb-6">
              Form Level Classes
            </h3>
            <ul className="space-y-4">
              {teacherData.classes
                .filter((cls) => cls.ClassType === 'Form Level')
                .map((cls) => (
                  <li
                    key={cls.ClassID}
                    className="p-4 sm:p-5 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => handleClassClick(cls.ClassID, cls.ClassType)}
                  >
                    <div className="flex justify-between items-center">
                      <span className="text-base sm:text-lg font-semibold text-gray-900">
                        {cls.ClassName}
                      </span>
                      <span className="text-sm text-gray-500">Form {cls.Form}</span>
                    </div>
                  </li>
                ))}
            </ul>
          </div>

          {/* Subject Level Classes */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-4 sm:mb-6">
              Subject Level Classes
            </h3>
            <ul className="space-y-4">
              {teacherData.classes
                .filter((cls) => cls.ClassType === 'Subject Level')
                .map((cls) => (
                  <li
                    key={cls.ClassID}
                    className="p-4 sm:p-5 bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                    onClick={() => handleClassClick(cls.ClassID, cls.ClassType)}
                  >
                    <div className="flex justify-between items-center">
                      <span className="text-base sm:text-lg font-semibold text-gray-900">
                        {cls.ClassName}
                      </span>
                      <span className="text-sm text-gray-500">Form {cls.Form}</span>
                    </div>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
